// Templates.tsx
//
// Sub-tela "Templates" de Comunicações: o TEXTO que a mensagem tem. O gatilho
// continua em Suprimentos; o que a mensagem diz passa a viver aqui.
//
// Duas origens numa lista só, e a diferença fica na etiqueta:
//   · GRAVADO — linha de acd."ActOrganizationInfo", organizationInfoType 20,
//     que veio no infoToken.
//   · MODELO DO SISTEMA — semente de `templatesPadrao.ts`. Não está no banco de
//     ninguém: é ponto de partida. Mostrar semente com cara de registro salvo
//     seria a mentira do AlertsAndNotifications, que listava três templates
//     escritos como literal no meio do JSX como se fossem cadastro.
//
// A leitura do gravado, a lista de sementes, o rótulo do canal e a extração das
// variáveis vêm de `templatesPadrao.ts` — reescrevê-las aqui criaria duas
// versões da mesma regra, e a que divergisse ficaria mentindo em silêncio.
//
// Esta tela NÃO envia nem testa nada: não há botão de disparo, nem desabilitado.

import React from "react";
import * as AlfredoStyles from "../../../../styles/components/configuration/sections/comunicacoesSection/index";
import {
  TEMPLATES_PADRAO,
  ROTULO_CANAL,
  extrairVariaveis,
  lerTemplatesGravados,
  TemplateDeMensagem,
} from "../suppliesSection/templatesPadrao";

interface Props {
  decryptedInfoToken: any;
  handleOpenModal: (type: string, object?: any) => void;
}

const Templates: React.FC<Props> = ({ decryptedInfoToken, handleOpenModal }) => {
  const gravados = lerTemplatesGravados(decryptedInfoToken);

  // Gravado primeiro: é o que vale. As sementes vêm depois, marcadas.
  const todos: TemplateDeMensagem[] = [...gravados, ...TEMPLATES_PADRAO];

  return (
    <AlfredoStyles.FieldsContainer>
      <AlfredoStyles.Header>
        <AlfredoStyles.HeaderContent>
          <AlfredoStyles.HeaderTitle>
            <AlfredoStyles.MaterialIcons
              style={{ fontSize: "calc(var(--u) * 36)" }}
            >
              description
            </AlfredoStyles.MaterialIcons>
            Templates
          </AlfredoStyles.HeaderTitle>
          <AlfredoStyles.HeaderSubtitle>
            O texto das mensagens da rede. Quem dispara é o alerta em
            Suprimentos — esta tela não envia nada.
          </AlfredoStyles.HeaderSubtitle>
        </AlfredoStyles.HeaderContent>

        <AlfredoStyles.Button onClick={() => handleOpenModal("messageTemplate")}>
          <AlfredoStyles.MaterialIcons style={{ fontSize: "var(--fs-base)" }}>
            add
          </AlfredoStyles.MaterialIcons>
          Novo template
        </AlfredoStyles.Button>
      </AlfredoStyles.Header>

      {/* O recado vem ANTES da digitação, não depois do clique em Salvar. */}
      <AlfredoStyles.AvisoTopo $tom="atencao">
        Gravar template ainda não está ligado. O modal salva com
        <code> messageTemplate</code>, string que o salvamento do shell não
        conhece: ele devolve a recusa nomeada e nenhuma requisição sai. Os itens
        marcados como <strong>modelo do sistema</strong> não estão no banco —
        são ponto de partida do texto, não cadastro.
      </AlfredoStyles.AvisoTopo>

      {todos.length === 0 ? (
        <AlfredoStyles.EmptyState>
          <AlfredoStyles.EmptyStateIcon>✉️</AlfredoStyles.EmptyStateIcon>
          <AlfredoStyles.EmptyStateTitle>
            Nenhum template
          </AlfredoStyles.EmptyStateTitle>
          <AlfredoStyles.EmptyStateDescription>
            Não há template gravado na rede e nenhum modelo do sistema foi
            carregado.
          </AlfredoStyles.EmptyStateDescription>
        </AlfredoStyles.EmptyState>
      ) : (
        <AlfredoStyles.Lista>
          {todos.map((template, indice) => {
            // Semente não tem uuid; gravado tem. É essa a única diferença que o
            // usuário precisa enxergar, e é a que decide o rótulo do botão.
            const gravado = Boolean(template.organizationInfoUuid);
            const variaveis = extrairVariaveis(template.conteudo);

            return (
              <AlfredoStyles.ListaItem
                key={template.organizationInfoUuid ?? `semente-${indice}`}
              >
                <AlfredoStyles.ListaItemCorpo>
                  <AlfredoStyles.ListaItemTitulo>
                    {template.nome}
                    <AlfredoStyles.Etiqueta
                      $tom={gravado ? "gravado" : "semente"}
                    >
                      {gravado ? "gravado" : "modelo do sistema"}
                    </AlfredoStyles.Etiqueta>
                    <AlfredoStyles.Etiqueta>
                      {ROTULO_CANAL[template.canal] ?? template.canal}
                    </AlfredoStyles.Etiqueta>
                  </AlfredoStyles.ListaItemTitulo>

                  <AlfredoStyles.Trecho>
                    {template.conteudo || "(sem texto)"}
                  </AlfredoStyles.Trecho>

                  <AlfredoStyles.Variaveis>
                    <AlfredoStyles.AjudaCampo>
                      Variáveis lidas do próprio texto:
                    </AlfredoStyles.AjudaCampo>
                    {variaveis.length === 0 ? (
                      <AlfredoStyles.AjudaCampo>
                        nenhuma
                      </AlfredoStyles.AjudaCampo>
                    ) : (
                      variaveis.map((variavel) => (
                        <AlfredoStyles.Variavel key={variavel}>
                          {`{${variavel}}`}
                        </AlfredoStyles.Variavel>
                      ))
                    )}
                  </AlfredoStyles.Variaveis>
                </AlfredoStyles.ListaItemCorpo>

                <AlfredoStyles.SecondaryButton
                  onClick={() => handleOpenModal("messageTemplate", template)}
                >
                  <AlfredoStyles.MaterialIcons
                    style={{ fontSize: "var(--fs-base)" }}
                  >
                    edit
                  </AlfredoStyles.MaterialIcons>
                  {gravado ? "Editar" : "Usar como base"}
                </AlfredoStyles.SecondaryButton>
              </AlfredoStyles.ListaItem>
            );
          })}
        </AlfredoStyles.Lista>
      )}
    </AlfredoStyles.FieldsContainer>
  );
};

export default Templates;
